<template>
  <layout-main-inner title="商家信誉管理">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增商家
      </el-button>
      <el-dropdown>
        <el-button
          type="primary"
          style="margin-left: 10px">
          更多<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="downloadtmp">下载商家模板</el-dropdown-item>
          <el-dropdown-item @click.native="uploadtmp">上传商家信息</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.customerNumber"
          clearable
          placeholder="请输入商家编码"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="商家编码"
          width="100"
          fixed="left"
          prop="customerNumber">
        </el-table-column>
        <el-table-column
          label="商家名称"
          min-width="160"
          prop="name">
        </el-table-column>
        <el-table-column
          label="信誉等级(0-6)"
          width="165"
          prop="level">
          <template slot-scope="{ row }">
            <el-rate
              disabled
              :value="row.level"
              :max="6"></el-rate>
          </template>
        </el-table-column>
        <el-table-column
          label="联系人"
          width="120"
          prop="contactMan">
        </el-table-column>
        <el-table-column
          label="联系电话"
          width="100"
          prop="contactPhone">
        </el-table-column>
        <el-table-column
          label="地址"
          min-width="200"
          prop="address">
        </el-table-column>
        <el-table-column
          label="有效期"
          width="90">
          <template slot-scope="{ row }">
            <span>{{ row.validDate | dateformat('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="图片"
          width="50">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              :disabled="!row.images"
              @click="showImage(row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="145">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">编辑</el-button>
            <el-button
              type="danger"
              @click="deleteitem(row)">删除</el-button>
            <!-- <el-dropdown>
              <el-button
                type="primary"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="deleteitem(row)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </layout-card-wrap>
    <el-upload
      ref="elUpload"
      action=""
      :limit="1"
      style="display: none;"
      accept=".xls,.xlsx"
      :show-file-list="false"
      :http-request="handleHttpRequest">
      <i ref="upload"></i>
    </el-upload>

    <edit-credit-modal
      ref="credit"
      :callback="getlist" />

    <image-modal ref="image" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditCreditModal from './busi/edit-credit-modal.vue'
import ImageModal from './busi/image-modal.vue'

export default {
  name: 'CreditList',
  components: { EditCreditModal, ImageModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      courseExamId: null,
      config: {
        pageNum: 1,
        pageSize: 10,
        customerNumber: ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    showImage(row) {
      this.$refs.image.edit(row.images.split(','))
    },
    downloadtmp() {
      this.loading = true
      this.$store.dispatch('account/downloadcustomercredittemplate', {
        payload: {},
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    uploadtmp() {
      this.$refs.upload.click()
    },
    handleHttpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('courseExamId', this.courseExamId)
      this.loading = true
      this.$store.dispatch('account/uploadcustomercredit', {
        payload: formData,
        success: () => {
          this.loading = false
          this.$message.success('上传成功')
          this.$refs.elUpload.clearFiles()
          this.getlist()
        },
        fail: () => {
          this.$refs.elUpload.clearFiles()
          this.loading = false
        }
      })
    },
    updateitem(row) {
      this.$refs.credit.edit({
        ...row,
        images: row.images ? row.images.split(',').map(url => ({ url })) : []
      })
    },
    additem() {
      this.$refs.credit.edit()
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该信誉商家?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletecustomercredit', {
          payload: {
            id: row.id
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getcustomercredits', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
